import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../assets/LogoDindorf.png';
import './header.styles.scss';

const Header = () => {
    const [show, setShow] = useState(false);
    const location = useLocation(); // Hook para obtener la ruta actual
    
    const closeMenu = () => setShow(false);
    const toggleMenu = () => setShow(!show);
    
    // Función para verificar si el link está activo
    const isActive = (path) => {
        return location.pathname === path;
    };
    
    useEffect(() => {
        const onScroll = () => {
            const scrollY = window.scrollY;
            const header = document.querySelector('.header');
            if (!header) return;
            
            if (scrollY >= 50) {
                header.classList.add('header-scroll');
            } else {
                header.classList.remove('header-scroll');
            }
        };
        
        window.addEventListener('scroll', onScroll);
        
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);


    return (
        <div className='header'>
            <nav className='container nav'>
                <Link to='/' className='logo' onClick={closeMenu}>
                    <img
                        src={Logo}
                        alt='LogoDindorf'
                        style={{
                            width: '140px',
                            height: '140px',
                            objectFit: 'contain',
                            display: 'block'
                        }}
                        className='logo-image'
                    />
                </Link>

                <div className={`menu ${show ? 'show' : ''}`}>
                    <ul className='nav-list'>
                        <li className='nav-item'>
                            <Link
                                to='/'
                                className={`link ${isActive('/') ? 'active' : ''}`}
                                onClick={closeMenu}
                            >
                                Nosotros
                            </Link>
                        </li>
                        {/* <li className='nav-item'>
                            <Link
                                to='/nosotros'
                                className='link'
                                onClick={closeMenu}
                            >
                                Nosotros
                            </Link>
                        </li> */}
                        <li className='nav-item'>
                            <Link
                                to='/equipo'
                                className={`link ${isActive('/equipo') ? 'active' : ''}`}
                                onClick={closeMenu}
                            >
                                Equipo
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                to='/servicios'
                                className={`link ${isActive('/servicios') ? 'active' : ''}`}
                                onClick={closeMenu}
                            >
                                Servicios
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                to='/usados'
                                className={`link ${isActive('/usados') ? 'active' : ''}`}
                                onClick={closeMenu}
                            >
                                USADOS
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link 
                                to='/0km' 
                                className={`link ${isActive('/0km') ? 'active' : ''}`}
                                onClick={closeMenu}
                            >
                                0KM
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link 
                                to='/motos' 
                                className={`link ${isActive('/motos') ? 'active' : ''}`}
                                onClick={closeMenu}
                            >
                                MOTOS
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link 
                                to='/sponsors' 
                                className={`link ${isActive('/sponsors') ? 'active' : ''}`}
                                onClick={closeMenu}
                            >
                                SPONSORS
                            </Link>
                        </li>
                    </ul>
                </div>
                
                <div className='nav-toggle' onClick={toggleMenu}>
                    <i className={show ? 'ri-close-line' : 'ri-menu-line'}></i>
                </div>
            </nav>
        </div>
    );
};

export default Header;